module.exports = __webpack_public_path__ + "static/media/introWidget.49d13403.png";